import {lincolnToWashingtonContent, moriahSchool, washingtonToLincolnContent} from "./questionContentReflectingPool";
import {jeffersonToMlkContent, mlkToJeffersonContent} from "./questionContentTidalBasin";
import {freeTextQuestion} from "./questionTypes";
import tidalBasinMap from "../../images/tidalBasin/TidalBasinMap.jpg";
import reflectingPoolMap from "../../images/reflectingPool/ReflectingPoollMap.jpg";
import washSquareParkMap from "../../images/washSqPark/washSquareParkMap.jpg";
import ReflectingPoolCropped from "../../images/reflectingPool/ReflectingPoolCropped.jpg";
import TidalBasinCropped from "../../images/tidalBasin/TidalBasinCropped.jpg";
import washSquareMapCropped from "../../images/washSqPark/washSquareMapCropped.jpg";
import {testCourseContent} from "./questionContentTestCourse";
import {paulBdayCourseContent, paulTriviaContent, washSqParkCourseContent} from "./questionContentWashSqPark";
import {brooklynPromenadeCourseContent} from "./questionContentBrooklynPromenade";
import lincolnIcon from "../../images/reflectingPool/courseSelectionPreviews/LincolnIcon.png";
import washMonIcon from "../../images/reflectingPool/courseSelectionPreviews/WashMonIcon.png";
import mlkIcon from "../../images/tidalBasin/courseSelectionPreviews/MlkIcon.png";
import archIcon from "../../images/washSqPark/archIcon.png";
import jeffersonIcon from "../../images/tidalBasin/courseSelectionPreviews/JeffersonIcon.png";
import PaulCake from "../../images/paulBirthday/PaulCake.png";
import PaulHandstand from "../../images/paulBirthday/PaulHandstand.png";
import PaulSpock from "../../images/paulBirthday/PaulSpock.png";
import reflectingLincolnStatue from "../../images/reflectingPool/courseSelectionPreviews/reflectingLincolnStatue.jpg";
import reflectingPoolKorean from "../../images/reflectingPool/courseSelectionPreviews/reflectingPoolKorean.jpg";
import reflectingPoolLincoln from "../../images/reflectingPool/courseSelectionPreviews/reflectingPoolLincoln.jpg";
import reflectingPoolMoriah from "../../images/reflectingPool/courseSelectionPreviews/reflectingPoolMoriah.jpg";
import reflectingPoolView from "../../images/reflectingPool/courseSelectionPreviews/reflectingPoolView.jpg";
import reflectingPoolWWII from "../../images/reflectingPool/courseSelectionPreviews/reflectingPoolWWII.jpg";
import reflectingThreeStatues from "../../images/reflectingPool/courseSelectionPreviews/reflectingThreeStatues.jpg";
import tidalBasinFDRline from "../../images/tidalBasin/courseSelectionPreviews/tidalBasinFDRline.jpg";
import tidalBasinFDRrocks from "../../images/tidalBasin/courseSelectionPreviews/tidalBasinFDRrocks.jpg";
import tidalBasinJefferson from "../../images/tidalBasin/courseSelectionPreviews/tidalBasinJefferson.jpg";
import tidalBasinMason from "../../images/tidalBasin/courseSelectionPreviews/tidalBasinMason.jpg";
import tidalBasinMLK from "../../images/tidalBasin/courseSelectionPreviews/tidalBasinMLK.jpg";
import tidalBasinPath from "../../images/tidalBasin/courseSelectionPreviews/tidalBasinPath.jpg";
import washSquare1 from "../../images/washSqPark/courseSelectionPreview/washSquare1.jpg";
import washSquare2 from "../../images/washSqPark/courseSelectionPreview/washSquare2.jpg";
import washSquare3 from "../../images/washSqPark/courseSelectionPreview/washSquare3.jpg";
import washSquare4 from "../../images/washSqPark/courseSelectionPreview/washSquare4.jpg";
import promenadeFidiView from "../../images/promenade/courseCoverPics/FidiView.jpg";
import promenadePromenadeSunset from "../../images/promenade/courseCoverPics/PromenadeSunset.jpg";
import promenadeStatueOfLiberty from "../../images/promenade/courseCoverPics/StatueOfLiberty.jpg";
import promenadeBkBridgeSunset from "../../images/promenade/courseCoverPics/BkBridgeSunset.jpg";
import promenadeSundialIcon from "../../images/promenade/courseCoverPics/Sundial Icon.png";

export const CITIES = {
  newYorkCity: "New York City",
  washingtonDC: "Washington, D.C.",
};

export const lincolnToWashington = {
  key: 'lincolnToWashington',
  experienceId: 'reflectingPoolClassic',
  friendlyCourseName: 'Lincoln To Washington',
  courseContent: lincolnToWashingtonContent,
  coverPhoto: reflectingPoolLincoln,
  map: reflectingPoolMap,
  mapPreview: ReflectingPoolCropped,
  paymentLink: 'https://buy.stripe.com/aEUbLR3da3nc5zO4gl ',
  startOption: {
    name: 'Lincoln Memorial',
    icon: lincolnIcon,
    courseName: 'lincolnToWashington',
    googleMapsLink: 'https://goo.gl/maps/NwBRRnk7gX2G6hXm9',
  },
};

export const moriahSchoolCourse = {
  key: 'moriahSchoolCourse',
  experienceId: 'moriahReflectingPool',
  friendlyCourseName: 'Moriah School DC Trip',
  courseContent: moriahSchool,
  coverPhoto: reflectingPoolMoriah,
  map: reflectingPoolMap,
  mapPreview: ReflectingPoolCropped,
  paymentLink: 'https://buy.stripe.com/aEUbLR3da3nc5zO4gl ',
  startOption: {
    name: 'Lincoln Memorial',
    icon: lincolnIcon,
    courseName: 'moriahSchoolCourse',
    googleMapsLink: 'https://goo.gl/maps/NwBRRnk7gX2G6hXm9',
  },
};

export const washingtonToLincoln = {
  key: 'washingtonToLincoln',
  experienceId: 'reflectingPoolClassic',
  friendlyCourseName: 'Washington To Lincoln',
  courseContent: washingtonToLincolnContent,
  coverPhoto: reflectingPoolView,
  map: reflectingPoolMap,
  mapPreview: ReflectingPoolCropped,
  paymentLink: 'https://buy.stripe.com/aEUbLR3da3nc5zO4gl ',
  startOption: {
    name: 'Washington Monument',
    icon: washMonIcon,
    courseName: 'washingtonToLincoln',
    googleMapsLink: 'https://www.google.com/maps/place/Washington+Monument+Grounds/@38.8883615,-77.0381307,16z/data=!4m5!3m4!1s0x89b7b7a142170a97:0x161046a1d4decb29!8m2!3d38.8894565!4d-77.0381103',
  }
};

export const mlkToJefferson = {
  key: 'mlkToJefferson',
  experienceId: 'tidalBasinClassic',
  friendlyCourseName: 'MLK to Jefferson',
  courseContent: mlkToJeffersonContent,
  coverPhoto: tidalBasinMLK,
  map: tidalBasinMap,
  mapPreview: TidalBasinCropped,
  paymentLink: 'https://buy.stripe.com/9AQ039aFC7Dsd2g7sy',
  startOption: {
    name: 'MLK Jr. Memorial',
    icon: mlkIcon,
    courseName: 'mlkToJefferson',
    googleMapsLink: 'https://goo.gl/maps/fvkDC4WxPDwAX1sn6',
  },
};

export const jeffersonToMlk = {
  key: 'jeffersonToMlk',
  experienceId: 'tidalBasinClassic',
  friendlyCourseName: 'Jefferson to MLK',
  courseContent: jeffersonToMlkContent,
  coverPhoto: tidalBasinJefferson,
  map: tidalBasinMap,
  mapPreview: TidalBasinCropped,
  paymentLink: 'https://buy.stripe.com/9AQ039aFC7Dsd2g7sy',
  startOption: {
    name: 'Jefferson Memorial',
    icon: jeffersonIcon,
    courseName: 'jeffersonToMlk',
    googleMapsLink: 'https://goo.gl/maps/V7Qwea6LSTgb4wkH6',
  }
};

export const testCourse = {
  key: 'testCourse',
  experienceId: 'testCourse',
  friendlyCourseName: 'Test Course',
  courseContent: testCourseContent,
  coverPhoto: washSquare1,
  map: washSquareParkMap,
  mapPreview: washSquareMapCropped,
  paymentLink: 'https://buy.stripe.com/9AQ039aFC7Dsd2g7sy',
  startOption: {
    name: 'Washington Arch (Test)',
    icon: archIcon,
    courseName: 'testCourse',
    googleMapsLink: 'https://goo.gl/maps/kvau7xZBU6ryE4NQ6?coh=178573&entry=tt',
  },
};

export const washSqPark = {
  key: 'washSqPark',
  experienceId: 'washSqPark',
  friendlyCourseName: 'Washington Square Park Course',
  courseContent: washSqParkCourseContent,
  coverPhoto: washSquare1,
  map: washSquareParkMap,
  mapPreview: washSquareMapCropped,
  paymentLink: 'https://buy.stripe.com/9AQ039aFC7Dsd2g7sy',
  startOption: {
    name: 'Washington Arch',
    icon: archIcon,
    courseName: 'washSqPark',
    googleMapsLink: 'https://goo.gl/maps/kvau7xZBU6ryE4NQ6?coh=178573&entry=tt',
  },
};

export const paulBDay = {
  key: 'paulBDay',
  experienceId: 'paulBirthdayAtWsp',
  friendlyCourseName: "Paul's birthday at WSP",
  courseContent: paulBdayCourseContent,
  coverPhoto: PaulCake,
  map: washSquareParkMap,
  mapPreview: washSquareMapCropped,
  paymentLink: 'https://buy.stripe.com/9AQ039aFC7Dsd2g7sy',
  startOption: {
    name: 'Washington Arch',
    icon: archIcon,
    courseName: 'paulBDay',
    googleMapsLink: 'https://goo.gl/maps/kvau7xZBU6ryE4NQ6?coh=178573&entry=tt',
  },
};

export const paulTrivia = {
  key: 'paulTrivia',
  experienceId: 'paulBirthdayAtWsp',
  friendlyCourseName: "Paul's birthday at WSP",
  courseContent: paulTriviaContent,
  coverPhoto: PaulSpock,
  map: washSquareParkMap,
  mapPreview: washSquareMapCropped,
  paymentLink: 'https://buy.stripe.com/9AQ039aFC7Dsd2g7sy',
  startOption: {
    name: 'Washington Arch',
    icon: archIcon,
    courseName: 'paulTrivia',
    googleMapsLink: 'https://goo.gl/maps/kvau7xZBU6ryE4NQ6?coh=178573&entry=tt',
  },
};

export const brooklynPromenade = {
  key: 'brooklynPromenade',
  experienceId: 'brooklynPromenade',
  friendlyCourseName: 'Brooklyn Promenade',
  courseContent: brooklynPromenadeCourseContent,
  coverPhoto: promenadePromenadeSunset,
  //map: washSquareParkMap,
  //mapPreview: washSquareMapCropped,
  paymentLink: 'https://buy.stripe.com/9AQ039aFC7Dsd2g7sy', // placeholder – reuse standard NYC link
  startOption: {
    name: 'Sundial at the Promenade entrance by Orange Street',
    icon: promenadeSundialIcon,
    courseName: 'brooklynPromenade',
    googleMapsLink: 'https://maps.app.goo.gl/QHwd4jURsyn2hMzT8',
  },
};

export const courses = {
  lincolnToWashington,
  moriahSchoolCourse,
  washingtonToLincoln,
  mlkToJefferson,
  jeffersonToMlk,
  testCourse,
  washSqPark,
  paulBDay,
  paulTrivia,
  brooklynPromenade,
};

export const experiences = {
  moriahReflectingPool: {
    id: 'moriahReflectingPool',
    name: 'Moriah School Trip - Scavenger Hunt around the Reflecting Pool',
    city: CITIES.washingtonDC,
    locationInCity: 'National Mall',
    images: [reflectingPoolMoriah, reflectingPoolView, reflectingPoolLincoln, reflectingLincolnStatue, reflectingThreeStatues, reflectingPoolKorean],
    shortDescription: 'The area around the Reflecting Pool has something for everyone - fascinating and moving war memorials, pleasant walking paths, and delightful scenery.',
    longDescription: 'The area around the Reflecting Pool has something for everyone - fascinating and moving war memorials, pleasant walking paths, and delightful scenery. Of note, this course starts at the Lincoln Memorial, and features several war memorials (WWII, Vietnam, Korean) and the Washington Monument.',
    distance: '2mi',
    time: '1.5h',
    destinationQuant: 5,
    variantKeys: ['moriahSchoolCourse'],
    defaultCourseKey: 'moriahSchoolCourse',
    availabilityWindow: {start: '2026-05-06', end: '2026-05-16'},
  },
  reflectingPoolClassic: {
    id: 'reflectingPoolClassic',
    name: 'Memorials Around the Reflecting Pool',
    city: CITIES.washingtonDC,
    locationInCity: 'National Mall',
    images: [reflectingPoolView, reflectingPoolLincoln, reflectingLincolnStatue, reflectingPoolWWII, reflectingThreeStatues, reflectingPoolKorean],
    shortDescription: 'The area around the Reflecting Pool has something for everyone - fascinating and moving war memorials, pleasant walking paths, and delightful scenery.',
    longDescription: 'The area around the Reflecting Pool has something for everyone - fascinating and moving war memorials, pleasant walking paths, and delightful scenery. Of note, this course features the Lincoln Memorial, several war memorials (WWII, Vietnam, Korean), and the Washington Monument.',
    distance: '2.3mi',
    time: '2h',
    destinationQuant: 6,
    variantKeys: ['lincolnToWashington', 'washingtonToLincoln'],
    defaultCourseKey: 'lincolnToWashington',
  },
  tidalBasinClassic: {
    id: 'tidalBasinClassic',
    name: 'Famous Figures at the Tidal Basin',
    city: CITIES.washingtonDC,
    locationInCity: 'National Mall',
    images: [tidalBasinJefferson, tidalBasinFDRrocks, tidalBasinMLK, tidalBasinMason, tidalBasinPath, tidalBasinFDRline],
    shortDescription: 'A walking tour around the Tidal Basin is scenic and fulfilling as you visit memorials to those that have had monumental impacts on American History.',
    longDescription: 'A walking tour around the Tidal Basin is scenic and fulfilling as you visit memorials to those that have had monumental impacts on American History. Take in the words from figures such as MLK, FDR, Mason, and Jefferson, and be in awe of the beautiful memorials that honor them. The nature is an attraction in itself in the spring time as you walk through tunnels of cherry trees.',
    distance: '1.2mi',
    time: '1h',
    destinationQuant: 6,
    variantKeys: ['mlkToJefferson', 'jeffersonToMlk'],
    defaultCourseKey: 'mlkToJefferson',
  },
  washSqPark: {
    id: 'washSqPark',
    name: 'Washington Square Park',
    city: CITIES.newYorkCity,
    locationInCity: 'Downtown',
    images: [washSquare1, washSquare2, washSquare3, washSquare4],
    shortDescription: "Washington Square Park is a beautiful and historic park in the heart of Greenwich Village. It's a great place to relax, take a walk, or enjoy a picnic.",
    longDescription: "Washington Square Park is a beautiful and historic park in the heart of Greenwich Village. It's a great place to relax, take a walk, or enjoy a picnic. It also serves as a gathering place for musicians, street performers, and artists, as well as a site for various cultural events and protests. Its proximity to NYU means it's a popular hangout spot for students.",
    distance: '0.5 mi',
    time: '25 min',
    variantKeys: ['washSqPark'],
    defaultCourseKey: 'washSqPark',
  },
  paulBirthdayAtWsp: {
    id: 'paulBirthdayAtWsp',
    name: "Paul's Birthday at WSP",
    city: CITIES.newYorkCity,
    locationInCity: 'Downtown',
    images: [PaulCake, PaulSpock, PaulHandstand, washSquare1, washSquare2, washSquare3, washSquare4],
    shortDescription: "Washington Square Park has seen a lot over the years — protests, performances, even a public gallows. But today, it’s witnessing something truly special: Paul turning 34. 🎉",
    longDescription: "Washington Square Park has seen a lot over the years — protests, performances, even a public gallows. But today, it’s witnessing something truly special: Paul turning 34. 🎉\n\nThis course is part scavenger hunt, part roast, and all celebration. As you explore the park’s iconic landmarks and quirky corners, you’ll uncover not just history, but Paul-istory: a collection of trivia questions dedicated to the man of the hour. Expect deep dives into Paul's fridge, fitness habits, and hot takes, all woven into a classic Capital Clues hunt through one of NYC’s most vibrant spaces.\n\nReady to test your knowledge of Paul and the park? Let’s cook!",
    distance: '0.5 mi',
    time: '30 min',
    variantKeys: ['paulBDay', 'paulTrivia'],
    defaultCourseKey: 'paulBDay',
    availabilityWindow: {start: '2025-05-01', end: '2025-05-06'},
  },
  brooklynPromenade: {
    id: 'brooklynPromenade',
    name: 'Brooklyn Promenade',
    city: CITIES.newYorkCity,
    locationInCity: 'Brooklyn',
    images: [
      promenadePromenadeSunset,
      promenadeFidiView,
      promenadeStatueOfLiberty,
      promenadeBkBridgeSunset,
    ],
    shortDescription:
      'A walkway perched on the bluffs of Brooklyn Heights with sweeping views of Lower Manhattan.',
    longDescription:
      'A walkway perched on the bluffs of Brooklyn Heights with sweeping views of Lower Manhattan. Abraham Lincoln once said "There may be finer views than this in the world, but I don\'t believe it." This course will have you observing and discovering landmarks off in the distance as well as curiosities on the promenade itself.',
    distance: '0.5 mi',
    time: '25 min',
    variantKeys: ['brooklynPromenade'],
    defaultCourseKey: 'brooklynPromenade',
  },
  testCourse: {
    id: 'testCourse',
    name: 'Test Course',
    city: CITIES.newYorkCity,
    locationInCity: 'Downtown',
    images: [washSquare1, washSquare2, washSquare3, washSquare4],
    shortDescription: 'Internal Capital Clues test course for QA runs.',
    longDescription:
      'Internal Capital Clues test course for QA runs. This internal test course is only visible in the QA environment. Use it to validate game flows, course selection, and scoring without touching production-facing content.',
    distance: '0.5 mi',
    time: '20 min',
    destinationQuant: 0,
    variantKeys: ['testCourse'],
    defaultCourseKey: 'testCourse',
  },
};

export let coursesKeys = [];
for (const [key, ] of  Object.entries(courses)){
  coursesKeys.push(key);
}

export const fetchCourseContent = (courseKey) => {
  if (!courseKey || !courses[courseKey]) {
    return null;
  }
  const courseContent = courses[courseKey].courseContent;
  return (courseContent)
};

export const getTotalQsByLocation = (courseContent) => {
  if (!courseContent) {
    return {};
  }

  const locationArray = [];
  const locationCalc = (obj) => {
    for (const [, value] of Object.entries(obj)) {
      value.type === freeTextQuestion && locationArray.push(value.location && value.location.name)
    }
  };
  locationCalc(courseContent);
  const totalQsByLocation = locationArray.reduce((cnt, cur) => (cnt[cur] = cnt[cur] + 1 || 1, cnt), {});
  return (totalQsByLocation);
};

export const courseFriendlyName =
  (courseKey) => (courses?.[courseKey]?.friendlyCourseName);

export const courseHasMap = (courseKey) => Boolean(courses?.[courseKey]?.map);